import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const postVerifiedDomain = async (email) => {
  const apiURL = API_HOST + '/verified_domains';
  const { token, userID } = useCurrentUser();
  
  try {
    const { data } = await axios.post(apiURL,{
      verified_domain:{
          email: email,
        }
    },{
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+token,
        'x-sb-user-id': userID
      }
    });
    return data.data;
  } catch (error) {
    console.error(error);
  }
};
